document.addEventListener("DOMContentLoaded", function () {
  const thumbsSwiper = new Swiper(".product-thumbs-swiper", {
    direction: "vertical",
    slidesPerView: 4,
    spaceBetween: 10,
    speed: 600,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    // navigation: {
    //   nextEl: ".thumb-next",
    //   prevEl: ".thumb-prev",
    // },
    breakpoints: {
      0: {
        direction: "vertical",
        slidesPerView: 4.5,
        spaceBetween: 8,
      },
      581: {
        direction: "horizontal",
        spaceBetween: 4,
      },
      992: {
        direction: "horizontal",
        spaceBetween: 10,
      },
    },
  });

  // Main product media swiper
  const mainSwiper = new Swiper(".product-media-swiper", {
    spaceBetween: 10,
    loop: true,
    speed: 600,
    navigation: {
      nextEl: ".product_main_next",
      prevEl: ".product_main_prev",
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
    pagination: {
      el: ".product-media__pagination",
      type: "progressbar",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.1,
        spaceBetween: 0,
      },
      581: {
        slidesPerView: 1,
        spaceBetween: 25,
      },
    },
  });
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".zoom-btn");
    if (!btn) return;

    const slide = btn.closest(".swiper-slide");
    const img = slide.querySelector("img");

    const modal = document.querySelector(".zoom-modal");
    const modalImg = modal.querySelector("img");

    modalImg.src = img.dataset.full || img.src;
    modal.classList.add("active");
  });

  // close popup
  document.addEventListener("click", function (e) {
    if (
      e.target.classList.contains("zoom-overlay") ||
      e.target.classList.contains("zoom-close")
    ) {
      document.querySelector(".zoom-modal").classList.remove("active");
    }
  });
});
